var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.objekt && _vm.objekt.id)?_c('span',[_c('b-overlay',{attrs:{"show":_vm.showOverlay,"rounded":"sm"}},[_vm._v(" "+_vm._s(_vm.objekt.bezeichnung)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }